import type { PivotSelectionValue } from './types'

/** Renders a selected rectangle as tab-separated plain text — numbers raw, labels as shown, blanks empty. */
export const buildPivotSelectionTsv = (matrix: PivotSelectionValue[][]): string =>
  matrix.map((row) => row.map((value) => (value === undefined ? '' : String(value))).join('\t')).join('\n')
